import {
  type HierarchiesControllerGetChildrenQueryParamsScopeTypeEnumKey,
  hierarchiesControllerGetChildrenQueryParamsScopeTypeEnum,
} from "@dc/gateway-jsonapi";

export const DEFAULT_HIERARCHY_SCOPE_TYPE = hierarchiesControllerGetChildrenQueryParamsScopeTypeEnum.TEAM;

export type HierarchyScopeParams = {
  scopeId: string;
  scopeType: HierarchiesControllerGetChildrenQueryParamsScopeTypeEnumKey;
};
